// extracted by mini-css-extract-plugin
module.exports = {"container":"IconText_container__TrH8U","icon":"IconText_icon__9IoRv"};